import { useCallback, useRef } from 'react';
export var isPart = function (mayBePart) { return typeof mayBePart === 'string'; };
export var isPoint = function (mayBePoint) {
    return Array.isArray(mayBePoint)
        && mayBePoint.length === 2
        && typeof mayBePoint[0] === 'number'
        && typeof mayBePoint[1] === 'number';
};
export var isGeoObject = function (mayBeObj) {
    return typeof mayBeObj === 'object' && !isPoint(mayBeObj);
};
export var toPoint = function (pos) {
    var mayBePoint = pos === null || pos === void 0 ? void 0 : pos.split(',').map(Number).filter(function (p) { return !isNaN(p); });
    if (isPoint(mayBePoint)) {
        return mayBePoint;
    }
};
/**
 * deps пришлось добавить из-за начального состояния полученного от сервера, ниже код для примера:
 * ```
 * const request = useRefCallback<SuggestRequest>(...)
 *
 * useEffect(() => {
 *   if (point) {
 *     return request(point)
 *   }
 * }, [point, request])
 * ```
 * так как request имел постоянную ссылку, то эффект срабатывал один раз при изменении point,
 * но **до инициализации api**. поэтому, когда api проиниализировалось, то повторного запроса не было
 */
export var useCallbackRef = function (fn, deps) {
    if (deps === void 0) { deps = []; }
    var ref = useRef(fn);
    ref.current = fn;
    return useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return ref.current.apply(undefined, args);
    }, deps);
};
